import React, { useState, useEffect } from 'react';
import DetectorController, { HotelListType } from '../../controller/DetectorController';
import Select from 'react-select';
import toast, { Toaster } from 'react-hot-toast';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import StoreController from '../../controller/StoreController';
import { useNavigate } from 'react-router-dom';
import { managers } from '../../controller/ManagerController';

const StoreMenuCopy = () => {
  const navigate = useNavigate();
  const [targetStoreName, setTargetStoreName] = useState<string>('');
  const [targetStore, setTargetStore] = useState<any>(null);
  const [targetSearchStoreList, setTargetSearchStoreList] = useState<
    { store_id: number; store_name: string }[]
  >([]);

  const handleTargetStoreNameChange = (e: any) => {
    setTargetStoreName(e.target.value);
  };

  const storeTargetSelect = (data: any) => {
    setTargetStore(data);
    setTargetStoreName('');
    setTargetSearchStoreList([]);
  };

  const getTargetStoreByName = async (storeName: string) => {
    try {
      const oData = {
        store_name: storeName,
      };

      const response = await DetectorController.getStoreByName(oData);

      if (response && response.data) {
        setTargetSearchStoreList(response.data.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const [sourceStoreName, setSourceStoreName] = useState<string>('');
  const [sourceStore, setSourceStore] = useState<any>(null);
  const [sourceSearchStoreList, setSourceSearchStoreList] = useState<
    { store_id: number; store_name: string }[]
  >([]);

  const handleSourceStoreNameChange = (e: any) => {
    setSourceStoreName(e.target.value);
  };

  const storeSourceSelect = (data: any) => {
    setSourceStore(data);
    setSourceStoreName('');
    setSourceSearchStoreList([]);
  };

  const getSourceStoreByName = async (storeName: string) => {
    try {
      console.log('ddd');
      const oData = {
        store_name: storeName,
      };

      const response = await DetectorController.getStoreByName(oData);

      if (response && response.data) {
        setSourceSearchStoreList(response.data.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {}, []);

  return (
    <Style>
      <div className="rightContentWrap">
        <button className="backButton" onClick={() => navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <h2>KNOCKKNOCK 메뉴 복사</h2>
        <div className="listWrap">
          <div className="searchStore flex">
            <input
              value={targetStoreName}
              onChange={handleTargetStoreNameChange}
              type="text"
              placeholder="복사당할 매장을 선택해주세요"
            />
            <button onClick={() => getTargetStoreByName(targetStoreName)}>검색</button>
          </div>
          {targetSearchStoreList && targetSearchStoreList.length > 0 && (
            <div className="storeListWrap">
              {targetSearchStoreList.map((data, index) => (
                <div onClick={() => storeTargetSelect(data)} key={index} className="storeList flex">
                  <h2>{data.store_name}</h2>
                  <button>선택</button>
                </div>
              ))}
            </div>
          )}
        </div>
        {targetStore ? <h2>{targetStore.store_name}</h2> : <></>}
        <div className="listWrap">
          <div className="searchStore flex">
            <input
              value={sourceStoreName}
              onChange={handleSourceStoreNameChange}
              type="text"
              placeholder="메뉴를 가져올 매장을 선택해주세요"
            />
            <button onClick={() => getSourceStoreByName(sourceStoreName)}>검색</button>
          </div>
          {sourceSearchStoreList && sourceSearchStoreList.length > 0 && (
            <div className="storeListWrap">
              {sourceSearchStoreList.map((data, index) => (
                <div onClick={() => storeSourceSelect(data)} key={index} className="storeList flex">
                  <h2>{data.store_name}</h2>
                  <button>선택</button>
                </div>
              ))}
            </div>
          )}
        </div>
        {sourceStore ? <h2>{sourceStore.store_name}</h2> : <></>}

        <br></br>
        <br></br>
        {targetStore && sourceStore && targetStore.store_id !== sourceStore.store_id ? (
          <>
            {/* <h2>
              [{targetStore.store_name}] 에 [{sourceStore.store_name}] 매장 메뉴를 복사하시겠습니까?
            </h2>
            <button>복사</button> */}
            <h2>
              [{targetStore.store_name}] {'<==[메뉴]=='} [{sourceStore.store_name}]
            </h2>
            <h2 style={{ color: 'red' }}>
              복사 후 기존 [{targetStore.store_name}] 매장의 메뉴는 사라집니다.
            </h2>
            <h2 style={{ color: 'red' }}>신중히 복사해주세요.</h2>
            <div className="searchStore flex">
              <br />
              <h2>
                [{targetStore.store_name}] 에 [{sourceStore.store_name}] 매장 메뉴를
                복사하시겠습니까?
              </h2>
              <button
                onClick={async () => {
                  let adminName: string | null = prompt(
                    '관리자명을 입력해 주세요. 변경시 되돌릴 수 없습니다.',
                  );

                  if (adminName && managers.includes(adminName)) {
                    if (
                      window.confirm(
                        `[${targetStore.store_name}] 에 [${sourceStore.store_name}] 매장 메뉴를 복사하시겠습니까?`,
                      )
                    ) {
                      const response = await StoreController.copyMenu({
                        target_store_id: targetStore.store_id,
                        source_store_id: sourceStore.store_id,
                        admin_name: adminName,
                      });

                      if (response && response.data && response.data.ok) {
                        alert('복사 되었습니다.');
                        window.location.reload();
                      } else {
                        alert('오류입니다. 관리자에게 문의하세요.');
                      }
                    }
                  } else {
                    alert('등록되지않은 관리자입니다.');
                  }
                }}>
                복사
              </button>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </Style>
  );
};

export default StoreMenuCopy;

const Style = styled.div`
  .rightContentWrap {
    width: 100%;
    height: auto;
    background: #ffffff;
    padding: 2% 4%;
  }
  .listWrap {
    display: flex;
    flex-direction: column;
  }
  input {
    width: 100%;
    outline: none;
    padding: 10px 12px;
    border: none;
    border-bottom: 1px solid #aaa;
  }
  .css-b62m3t-container {
    width: 60%;
  }
  button {
    padding: 10px 24px;
    border: none;
    outline: none;
    border-radius: 4px;
    color: #fff;
  }
  h3 {
    font-size: 20px;
    font-weight: 400;
  }
  h4 {
    font-size: 18px;
    font-weight: 600;
  }
  p {
    font-size: 18px;
  }
  strong {
    color: #4dd2ae;
  }

  /* listWrap */
  .listWrap {
    margin-top: 30px;
  }
  /* searchStore */
  .searchStore {
    width: 60%;

    button {
      margin-left: 4px;
      white-space: nowrap;
      font-size: 16px;
      font-weight: 500;
      background: #000;
    }
  }

  /* storeListWrap */
  .storeListWrap {
    margin-top: 10px;
  }
  .storeList {
    width: 60%;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    justify-content: space-between;
    cursor: pointer;

    h2 {
      padding: 6px 12px;
      font-size: 16px;
      font-weight: 500;
    }
    button {
      background: gray;
    }
  }
  .storeList:hover {
    h2 {
      font-weight: 700;
    }
  }

  /* detailListWrap */
  .detailListWrap {
    margin-top: 30px;

    .content {
      margin: 60px 0;
      h4 {
        margin: 10px 0;
        color: #7a7a7a;
      }
    }
  }

  .dateWrap {
    margin-top: 30px;

    input {
      width: 40%;
    }
    p {
      width: 5%;
      white-space: nowrap;
    }
  }
  .dateWrap > div {
    margin-bottom: 10px;
  }
  .charge {
    p {
      margin-bottom: 16px;
    }
  }

  /* masterWrap */
  .masterWrap {
    margin-bottom: 30px;

    input {
      width: 30%;
    }
    p {
      width: 7%;
      white-space: nowrap;
    }
  }

  /* submitButton */
  .submitButton {
    width: 60%;
    background: #000;
    font-size: 18px;
    font-weight: 400;
    padding: 14px 10px;
  }
  .backButton {
    margin: 0;
    padding: 0;
  }
  .currentTime {
    background: gray;
  }

  @media (max-width: 1000px) {
    .storeList,
    .searchStore,
    .css-b62m3t-container,
    .submitButton {
      width: 100%;
    }
    .dateWrap,
    .masterWrap {
      input {
        flex: 1;
        font-size: 14px;
      }
      p {
        min-width: 50px;
      }
    }
  }
`;
